<div class="spacing--margin-horizontal spacing--margin-top">
  <ul class="info-header">
    <li>
      <label class="text-bold">{{ 'feed-advice.print.farmcompany' | translate }}:</label>
      <label class="wide-label" *ngIf="customer$ | async as customer">
        {{ customer?.name }}, {{ customer?.street }} {{ customer?.houseNumber }}
        {{ customer?.houseNumberAddition }}, {{ customer?.city }}
      </label>
    </li>
    <li>
      <label class="text-bold">{{ 'feed-advice.print.location' | translate }}:</label>
      <label class="wide-label" *ngIf="location$ | async as location">
        {{ location?.name }}, {{ location?.street }} {{ location?.houseNumber }}
        {{ location?.houseNumberAddition }}, {{ location?.city }}
      </label>
    </li>
    <li>
      <label class="text-bold">{{ 'feed-advice.print.customernr' | translate }}:</label>
      <label>{{ (customer$ | async)?.externalId }}</label>
    </li>
    <li>
      <label class="text-bold">{{ 'feed-advice.create.created' | translate }}:</label>
      <label class="wide-label"> {{ feedAdvice?.created | agrDate }}</label>
    </li>
    <li>
      <label class="text-bold">{{ 'feed-advice.create.updated' | translate }}:</label>
      <label class="wide-label"> {{ feedAdvice?.updated | agrDate }}</label>
    </li>
    <li *ngIf="feedAdvice?.numberOfDayOldChicks">
      <label class="text-bold">
        {{ 'feed-advice.create.number-of-day-old-chicks' | translate }}:
      </label>
      <label class="wide-label"> {{ feedAdvice?.numberOfDayOldChicks | agrNumber }}</label>
    </li>
    <li *ngIf="(customer$ | async)?.country === 'NL'">
      <label class="text-bold">{{ 'feed-advice.print.customerservice' | translate }}:</label>
      <label class="wide-label">{{ getCustomerServiceInfo((customer$ | async)?.country) }}</label>
    </li>
  </ul>
</div>
<h5 class="text--h5 spacing--padding-top">{{ 'feed-advice.create.products' | translate }}</h5>
<div class="wrapper--spacing-horizontal spacing--margin-horizontal">
  <table>
    <thead>
      <tr>
        <th></th>
        <th>{{ 'feed-advice.print.table-header.chickenWeightInGrams' | translate }}</th>
        <th>{{ 'feed-advice.print.table-header.age' | translate }}</th>
        <th>{{ 'feed-advice.print.table-header.totalFeed' | translate }}</th>
        <th [attr.colspan]="2">{{ 'feed-advice.print.table-header.gramPerChick' | translate }}</th>
        <th [attr.colspan]="2">{{ 'feed-advice.print.table-header.orderQuantity' | translate }}</th>
        <th *ngIf="hasProductComments()"></th>
      </tr>
      <tr>
        <th>{{ 'feed-advice.print.table-header.productName' | translate }}</th>
        <th>{{ 'feed-advice.print.table-header.units_gram' | translate }}</th>
        <th>{{ 'feed-advice.print.table-header.units_days' | translate }}</th>
        <th>{{ 'feed-advice.print.table-header.units_gram' | translate }}</th>
        <th>{{ 'feed-advice.print.table-header.coreFeed' | translate }}</th>
        <th>{{ 'feed-advice.print.table-header.wheatFeed' | translate }}</th>
        <th>{{ 'feed-advice.print.table-header.coreFeed' | translate }}</th>
        <th>{{ 'feed-advice.print.table-header.wheatFeed' | translate }}</th>
        <th *ngIf="hasProductComments()">
          {{ 'feed-advice.print.table-header.comment' | translate }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of feedAdvice.productRows">
        <td>{{ row.product?.code }} - {{ row.product?.name }}</td>
        <td style="text-align: center">{{ row.chickenWeightInGrams }}</td>
        <td style="text-align: center">
          {{ row.ageFrom }} - {{ row.ageTo ?? ('departure-title' | translate) }}
        </td>
        <td style="text-align: center">{{ row.totalFeed }}</td>
        <td style="text-align: center">{{ row.coreFeed }}</td>
        <td style="text-align: center">{{ row.wheatFeed }}</td>
        <td style="text-align: center">{{ calculateTons(row.coreFeed) }}</td>
        <td style="text-align: center">{{ calculateTons(row.wheatFeed) }}</td>
        <td *ngIf="hasProductComments()">{{ row.comment }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div *ngIf="hasAdditives()">
  <h5 class="text--h5 spacing--padding-top">{{ 'feed-advice.create.additives' | translate }}</h5>
  <div class="wrapper--spacing-horizontal spacing--margin-horizontal">
    <table>
      <thead>
        <tr>
          <th></th>
          <th>{{ 'feed-advice.print.table-header.dosage' | translate }}</th>
          <th>{{ 'feed-advice.print.table-header.applicationMoment' | translate }}</th>
          <th *ngIf="hasAdditiveComments()"></th>
        </tr>
        <tr>
          <th>{{ 'feed-advice.print.table-header.productName' | translate }}</th>
          <th>{{ 'feed-advice.print.table-header.units_kgton' | translate }}</th>
          <th></th>
          <th *ngIf="hasAdditiveComments()">
            {{ 'feed-advice.print.table-header.comment' | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of feedAdvice.additiveRows">
          <td>{{ row.product?.code }} - {{ row.product?.name }}</td>
          <td style="text-align: center">{{ row.dosage }}</td>
          <td style="text-align: center">{{ row.applicationMoment }}</td>
          <td *ngIf="hasAdditiveComments()">{{ row.comment }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="spacing--margin-horizontal extra-margin-top" *ngIf="feedAdvice?.description">
  <ul class="info-header">
    <li>
      <label class="text-bold">{{ 'feed-advice.create.description' | translate }}:</label>
      <pre class="wide-label">{{ feedAdvice?.description }}</pre>
    </li>
  </ul>
</div>
